import React from 'react';

import Head from './inner/Head';
import Skills from './inner/Skills';
import Projects from './inner/Projects';
import Story from './inner/Story';
import Contact from './Contact';

function Home(props) {
    return (
        <div className="main-container">
            
            {props.home.title_one ? 
                (
                    <Head title_one={props.home.title_one} title_two={props.home.title_two} icons={props.home.icons} />
                )
            : null}

            {props.home.skills ? 
                (
                    <Skills data={props.home.skills} />
                )
            : null}
            
            {props.home.projects ? 
                (
                    <Projects data={props.home.projects} />
                )
            : null}

            {props.home.story ?
                (
                    <Story data={props.home.story} />
                )
            : null }

            <Contact />

        </div>
    );
}

export default Home;